import React from "react";

import StackedChart from "../StackedChart";

import ClientActivityPanel from "./ClientActivityPanel";

const ClientInsightsRow = ({
  clientActivity,
  clientActivityLoading,
  isDarkMode,
}) => (
  <div className="grid h-full min-h-0 grid-cols-1 gap-3 overflow-hidden sm:gap-4 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
    <div className="dashboard-panel-surface flex min-h-[280px] flex-col overflow-hidden p-3 sm:min-h-0 sm:p-4 lg:h-full">
      <div className="min-h-0 flex-1">
        <StackedChart isDarkMode={isDarkMode} />
      </div>
    </div>
    <div className="dashboard-panel-surface min-h-[320px] overflow-hidden p-3 sm:min-h-0 sm:p-4 lg:h-full">
      <ClientActivityPanel
        showHeading
        clientActivity={clientActivity}
        loading={clientActivityLoading}
      />
    </div>
  </div>
);

export default ClientInsightsRow;
